import { IContent } from 'json-as-xlsx';
import { GridOptions } from 'ag-grid-community';
import {
  DirectSalesMediaType,
  DirectSalesMediaTypeLabel,
  SearchConfig,
} from 'components/common/types/DirectSalesCampaign.types';
import { SearchConfigFilterMapping } from './transformSearchConfig.types';

export const SAVE_SEARCH_CONFIG_DELAY = 500;

export const EMPTY_SEARCH_CONFIG: SearchConfig = { columns: [], filters: [] };

export const SEARCH_CONFIG_FILTER_MAPPINGS: SearchConfigFilterMapping[] = [
  { key: 'campaignStatus', field: 'CAMPAIGN_STATUS', operation: 'EQUAL', type: 'list' },
  { key: 'campaignName', field: 'CAMPAIGN_NAME', operation: 'CONTAINS', type: 'text' },
  { key: 'campaignReference', field: 'CAMPAIGN_LOOKUP_KEY', operation: 'CONTAINS', type: 'text' },
  { key: 'campaignMediaType', field: 'CAMPAIGN_MEDIA_TYPE', operation: 'EQUAL', type: 'text' },
  { key: 'startDate', field: 'START_DATE', operation: 'GREATER_OR_EQUAL', type: 'date' },
  { key: 'endDate', field: 'END_DATE', operation: 'LESS_OR_EQUAL', type: 'date' },
  { key: 'salesTeam', field: 'SALES_TEAM', operation: 'EQUAL', type: 'lookup' },
  { key: 'salesPerson', field: 'SALES_PERSON', operation: 'EQUAL', type: 'lookup' },
  { key: 'adminPerson', field: 'ADMIN_PERSON', operation: 'EQUAL', type: 'lookup' },
  { key: 'advertiser', field: 'ADVERTISER', operation: 'EQUAL', type: 'lookup' },
  { key: 'brand', field: 'BRAND', operation: 'EQUAL', type: 'lookup' },
  { key: 'productCategory', field: 'PRODUCT_CATEGORY', operation: 'EQUAL', type: 'lookup' },
  { key: 'agency', field: 'AGENCY', operation: 'EQUAL', type: 'lookup' },
  { key: 'specialist', field: 'SPECIALIST', operation: 'EQUAL', type: 'lookup' },
  { key: 'updatedBy', field: 'UPDATED_BY', operation: 'CONTAINS', type: 'text' },
  { key: 'createdBy', field: 'CREATED_BY', operation: 'CONTAINS', type: 'text' },
  { key: 'createdAt', field: 'CREATED_AT', operation: 'EQUAL', type: 'date' },
  { key: 'dropDate', field: 'DROP_DATE', operation: 'EQUAL', type: 'date' },
];

export const LOAD_SEARCH_CONFIG_ERROR_TOAST_ID = 'load-search-config-error';

export const SAVE_SEARCH_CONFIG_ERROR_TOAST_ID = 'save-search-config-error';

export const ASC_FIRST_SORTING_ORDER: GridOptions['sortingOrder'] = ['asc', 'desc'];

export const DESC_FIRST_SORTING_ORDER: GridOptions['sortingOrder'] = ['desc', 'asc'];

export const formatMediaTypeLabels = (types: DirectSalesMediaType[]): string =>
  types.map((type) => DirectSalesMediaTypeLabel[type]).join(', ');

export const TABLE_EXPORT_COLUMNS = [
  {
    label: 'Status',
    value: 'campaignStatus',
  },
  {
    label: 'Campaign name',
    value: 'campaignName',
  },
  {
    label: 'ID',
    value: (row: IContent) => row.userVisibleId || row.id,
  },
  {
    label: 'Media type',
    value: (row: IContent) => {
      const types = row.campaignMediaTypes as unknown as DirectSalesMediaType[];
      if (!types?.length) return '';
      return formatMediaTypeLabels(types);
    },
  },
  {
    label: 'From',
    value: 'startDate',
  },
  {
    label: 'To',
    value: 'endDate',
  },
  {
    label: 'Created date',
    value: 'createdAt',
  },
  {
    label: 'Updated date',
    value: 'updatedAt',
  },
  {
    label: 'Sales team',
    value: 'salesTeam',
  },
  {
    label: 'Sales person',
    value: 'salesPerson',
  },
  {
    label: 'Admin person',
    value: 'adminPerson',
  },
  {
    label: 'Advertiser',
    value: 'advertiser',
  },
  {
    label: 'Brand',
    value: 'brand',
  },
  {
    label: 'Product category',
    value: 'productCategory',
  },
  {
    label: 'Agency',
    value: 'agency',
  },
  {
    label: 'Specialist',
    value: 'specialist',
  },
  {
    label: 'Updated by',
    value: 'updatedBy',
  },
  {
    label: 'Drop date',
    value: 'dropDate',
  },
  {
    label: 'Created by',
    value: 'createdBy',
  },
];
